module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": _vm.showConnectionError,
      "type": "error"
    }
  }, [_vm._v("Couldn't Connect to Post Service! Please Comeback Later!")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [(_vm.currentUserRole === _vm.userRoles.INFLUENCER) ? _c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Campaign",
      "placeholder": "Campaign Name",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.campaignName),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignName", $$v)
      },
      expression: "filter.campaignName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentUserRole === _vm.userRoles.CLIENT) ? _c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.filterCampaigns,
      "label": "Campaign Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filter.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignID", $$v)
      },
      expression: "filter.campaignID"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Instagram",
      "placeholder": "Instagram Handle",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.filter, "instagramHandle", $$v)
      },
      expression: "filter.instagramHandle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER && _vm.currentUserRole !== _vm.userRoles.CLIENT) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": true,
      "item-text": "name",
      "item-value": "id",
      "items": _vm.clients,
      "outlined": true,
      "label": "Client",
      "placeholder": "Select Client"
    },
    model: {
      value: (_vm.filter.clientID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "clientID", $$v)
      },
      expression: "filter.clientID"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("Filter")]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.openViewPostLayout()
      }
    }
  }, [_vm._v("View All")])], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.showPostLayout) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.groupedPosts.length === 0) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('p', [_vm._v("No record found!")])])]) : _vm._e(), _vm._v(" "), _c('v-expansion-panels', _vm._l((_vm.groupedPosts), function(item, i) {
    return _c('v-expansion-panel', {
      key: i
    }, [_c('v-expansion-panel-header', [_c('p', {
      staticClass: "ma-0 title",
      staticStyle: {
        "color": "#3F3FFF"
      }
    }, [_vm._v(_vm._s(item._id.campaignName))]), _vm._v(" "), _c('v-btn', {
      staticStyle: {
        "max-width": "120px"
      },
      attrs: {
        "color": "purple",
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, null)
        }
      }
    }, [_vm._v("View Posts")])], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "lg": "3",
        "md": "4"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return _c('v-card', {
            staticClass: "mx-auto",
            class: ("elevation-" + (hover ? 12 : 2)),
            attrs: {
              "max-width": "250"
            }
          }, [_c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": "/static/img/upload-post-photo.png",
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, null)
              }
            }
          }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
            attrs: {
              "color": "purple",
              "text": ""
            },
            on: {
              "click": function($event) {
                return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, null)
              }
            }
          }, [_vm._v("View All Posts")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
        }
      }], null, true)
    })], 1), _vm._v(" "), _vm._l((item.influencers), function(inf, j) {
      return _c('v-col', {
        key: j,
        attrs: {
          "cols": "12",
          "md": "4",
          "lg": "3",
          "sm": "12"
        }
      }, [_c('v-hover', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var hover = ref.hover;

            return [(inf.owner) ? _c('v-card', {
              staticClass: "mx-auto",
              attrs: {
                "max-width": "250",
                "elevation": hover ? 12 : 2
              }
            }, [_c('v-card-title', [(inf.owner.tiktokHandle) ? _c('a', {
              attrs: {
                "href": 'https://www.tiktok.com/@' + inf.owner.tiktokHandle,
                "target": "_blank"
              }
            }, [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(inf.owner.tiktokHandle))]) : (inf.owner.youtubeHandle) ? _c('a', {
              attrs: {
                "href": 'https://youtube.com/' + inf.owner.youtubeHandle,
                "target": "_blank"
              }
            }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(inf.owner.youtubeHandle))], 1) : _c('a', {
              attrs: {
                "href": 'https://instagram.com/' + inf.owner.instagramHandle,
                "target": "_blank"
              }
            }, [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(inf.owner.instagramHandle))], 1)]), _vm._v(" "), _c('v-card-subtitle', [_vm._v(_vm._s(inf.noOfPosts) + " " + _vm._s(inf.noOfPosts > 1 ? 'Posts' : 'Post'))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
              attrs: {
                "color": "purple",
                "text": ""
              },
              on: {
                "click": function($event) {
                  return _vm.openViewPostLayout(item._id.campaignName, item._id.campaignID, inf.owner)
                }
              }
            }, [_vm._v("View Posts")]), _vm._v(" "), _c('v-spacer')], 1)], 1) : _vm._e()]
          }
        }], null, true)
      })], 1)
    })], 2)], 1)], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showPostLayout) ? _c('v-container', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "tile": "",
      "outlined": ""
    },
    on: {
      "click": _vm.closeViewPostLayout
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "align": "right"
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "left": "",
      "mandatory": "",
      "value": 0,
      "light": true
    },
    model: {
      value: (_vm.display),
      callback: function($$v) {
        _vm.display = $$v
      },
      expression: "display"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }], null, false, 159256613)
  }, [_vm._v(" "), _c('span', [_vm._v("List View")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({}, on), [_c('v-icon', [_vm._v("grid_on")])], 1)]
      }
    }], null, false, 207488929)
  }, [_vm._v(" "), _c('span', [_vm._v("Grid View")])])], 1)], 1)], 1), _vm._v(" "), (_vm.display === 1) ? _c('v-row', {
    staticStyle: {
      "min-height": "500px"
    },
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [(_vm.posts.length === 0) ? _c('v-flex', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('p', [_vm._v("No record found!")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(post, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "lg": "4",
        "md": "4"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return _c('v-card', {
            staticClass: "mx-auto",
            class: ("elevation-" + (hover ? 12 : 2))
          }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
            staticClass: "subtitle-1 ma-0"
          }, [_vm._v(_vm._s(post.campaignName))]), _vm._v(" "), _c('v-list-item-subtitle', {
            staticClass: "caption font-italic"
          }, [_vm._v("\n                      By\n                      "), (post.author.tiktokHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + post.author.tiktokHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(post.author.tiktokHandle))]) : (post.author.youtubeHandle) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + post.author.youtubeHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(post.author.youtubeHandle))], 1) : (post.author.xhsHandle) ? _c('a', {
            on: {
              "click": function($event) {
                return _vm.openLink('https://www.xiaohongshu.com/user/profile/' + post.author.xhsHandle)
              }
            }
          }, [_vm._v(_vm._s(post.author.xhsHandle))]) : (post.author.linkedinHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + post.author.linkedinHandle,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(post.author.linkedinHandle))], 1) : (post.type === 'twitter' || post.author.twitterHandle) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + _vm.getTwitterHandle(post),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(_vm.getTwitterHandle(post)))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + post.author.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(post.author.instagramHandle))], 1)])], 1)], 1), _vm._v(" "), (!post.images[0]) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": "/static/img/upload-post-photo.png",
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }) : _vm._e(), _vm._v(" "), (post.images[0] && !post.images[0].isvideo && !post.images[0].publicID) ? _c('v-img', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "src": post.images[0].url,
              "height": "194px"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }) : _vm._e(), _vm._v(" "), (post.images[0] && !post.images[0].isvideo && post.images[0].publicID) ? _c('div', {
            staticClass: "post-cld-img cursor-pointer",
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('custom-media-v2', {
            attrs: {
              "media": _vm.campaignHelper.customPostMediaConfig(post.images[0], {})
            }
          })], 1) : _vm._e(), _vm._v(" "), (post.images[0] && post.images[0].isvideo && !post.images[0].publicID) ? _c('video', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "height": "194px",
              "width": "100%"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('source', {
            attrs: {
              "src": post.images[0].url,
              "type": "video/mp4"
            }
          }), _vm._v("Your browser does not support the video tag.\n                ")]) : _vm._e(), _vm._v(" "), (post.images[0] && post.images[0].isvideo && post.images[0].publicID) ? _c('div', {
            staticStyle: {
              "max-height": "200px",
              "overflow": "hidden"
            },
            on: {
              "click": function($event) {
                return _vm.viewDetailPost(post)
              }
            }
          }, [_c('custom-media-v2', {
            attrs: {
              "media": _vm.campaignHelper.customPostMediaConfig(post.images[0], {
                videoPreview: true
              })
            }
          })], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [(post.type !== 'post/carousel' && post.vdoLink) ? _c('div', {
            staticStyle: {
              "margin-top": "10px"
            }
          }, [_c('v-btn', {
            staticClass: "ma-0",
            staticStyle: {
              "margin-top": "5px !important"
            },
            attrs: {
              "outlined": "",
              "color": "indigo",
              "target": "_blank",
              "href": post.vdoLink,
              "small": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("mdi-link")]), _vm._v("\n                        Video Link\n                      ")], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_vm._l((post.labels), function(label) {
            return _c('v-chip', {
              key: label.text,
              staticClass: "ma-1",
              attrs: {
                "small": "",
                "color": label.color,
                "outlined": label.outlined,
                "dark": label.dark
              },
              on: {
                "click": function($event) {
                  return _vm.exec(label.action, post)
                }
              }
            }, [(label.faIcon) ? _c('span', [_c('i', {
              class: label.faIcon
            }), _vm._v("  \n                    ")]) : _vm._e(), _vm._v("\n                    " + _vm._s(label.text) + "\n                    "), (label.icon) ? _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v(_vm._s(label.icon))]) : _vm._e()], 1)
          }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
            attrs: {
              "bottom": "",
              "right": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({
                  attrs: {
                    "icon": ""
                  }
                }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menuOptions), function(menuItem, i) {
            return (_vm.showAvailableMenu(post, menuItem.action)) ? _c('v-list-item', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.actionPostBy(menuItem.action, post)
                }
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(menuItem.icon))])], 1)], 1) : _vm._e()
          }), 1)], 1)], 2)], 1)
        }
      }], null, true)
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.display === 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "secondary"
          }
        }, on), [_vm._v("Bulk Action")])]
      }
    }], null, false, 1812722738)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.tableActions), function(menuItem, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "disabled": menuItem.disabled
      },
      on: {
        "click": function($event) {
          return _vm.performSelected(menuItem.action)
        }
      }
    }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "item-key": "_id",
      "show-select": true,
      "server-items-length": _vm.totalItems,
      "options": _vm.pagging,
      "headers": _vm.headers,
      "items": _vm.posts,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPage
      }
    },
    on: {
      "update:options": function($event) {
        _vm.pagging = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item._id
          }, [_c('td', [_c('v-checkbox', {
            attrs: {
              "checked": false,
              "value": item,
              "primary": "",
              "hide-details": ""
            },
            model: {
              value: (_vm.selected),
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.campaignName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-justify pa-1"
          }, [(item.author.tiktokHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author.youtubeHandle) ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + item.author.youtubeHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : (item.author.linkedinHandle) ? _c('a', {
            attrs: {
              "href": 'https://www.linkedin.com/in/' + item.author.linkedinHandle,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.author.linkedinHandle))], 1) : (item.type === 'twitter' || item.author.twitterHandle) ? _c('a', {
            attrs: {
              "href": 'https://x.com/' + _vm.getTwitterHandle(item),
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "15px",
              "alt": "",
              "aria-hidden": "true"
            }
          }), _vm._v(" @" + _vm._s(_vm.getTwitterHandle(item)))]) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.author.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1)]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._l((item.labels), function(label) {
            return _c('div', {
              key: label.text
            }, [_c('v-chip', {
              staticClass: "ma-1",
              attrs: {
                "small": "",
                "color": label.color,
                "outlined": label.outlined,
                "dark": label.dark
              },
              on: {
                "click": function($event) {
                  return _vm.exec(label.action, item)
                }
              }
            }, [(label.faIcon) ? _c('span', [_c('i', {
              class: label.faIcon
            }), _vm._v("  \n                          ")]) : _vm._e(), _vm._v("\n                          " + _vm._s(label.text) + "\n                          "), _c('v-icon', {
              attrs: {
                "right": ""
              }
            }, [_vm._v(_vm._s(label.icon))])], 1)], 1)
          }), _vm._v(" "), (_vm.currentUserRole !== _vm.userRoles.INFLUENCER && item.postURL) ? _c('div', [_c('v-btn', {
            attrs: {
              "rounded": "",
              "small": "",
              "color": "#F58529",
              "href": item.postURL,
              "target": "_blink"
            }
          }, [_vm._v("\n                          View on\n                          "), _c('v-icon', {
            attrs: {
              "right": ""
            }
          }, [_vm._v("mdi-instagram")])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm.formatDate(item.createdAt, 'LLL')))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_c('v-menu', {
            attrs: {
              "bottom": "",
              "left": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-btn', _vm._g({}, on), [_vm._v("\n                            Actions\n                            "), _c('v-icon', {
                  attrs: {
                    "right": ""
                  }
                }, [_vm._v("mdi-menu")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menuOptions), function(menuItem, i) {
            return (_vm.showAvailableMenu(item, menuItem.action)) ? _c('v-list-item', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.actionPostBy(menuItem.action, item)
                }
              }
            }, [_c('v-list-item-content', [_vm._v(_vm._s(menuItem.name))]), _vm._v(" "), _c('v-list-item-action', [_c('v-icon', [_vm._v(_vm._s(menuItem.icon))])], 1)], 1) : _vm._e()
          }), 1)], 1)], 1)])
        }), 0)]
      }
    }], null, false, 1620014219),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": _vm.showCsEditAction,
      "saleActions": _vm.showSaleAction,
      "clientActions": _vm.showClientEditAction,
      "influencerActions": _vm.showInfluencerEditAction,
      "cs_inf_chatbox": _vm.show_cs_inf_chatbox,
      "client_inf_chatbox": _vm.show_client_inf_chatbox,
      "postAbuseHistory": _vm.showPostAbuseHistory,
      "postReviewApproved": _vm.showPostReviewApproved,
      "postHistory": _vm.showPostHistory,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    on: {
      "csApproved": _vm.csApproveFromView,
      "saleReleased": _vm.saleReleasePost,
      "editPost": _vm.editPostFromView,
      "mainPostChanged": _vm.reloadPostView
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  }), _vm._v(" "), _c('edit-post-modal', {
    attrs: {
      "post": _vm.editPostData,
      "postAbuseHistory": _vm.showPostAbuseHistory,
      "value": _vm.editPostDialog,
      "userObj": _vm.user
    },
    on: {
      "postUpdated": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.editPostDialog),
      callback: function($$v) {
        _vm.editPostDialog = $$v
      },
      expression: "editPostDialog"
    }
  }), _vm._v(" "), _c('assign-campaign-modal', {
    attrs: {
      "post": _vm.assignCampaignPostData
    },
    on: {
      "success": function($event) {
        return _vm.assignedCampaign($event)
      }
    },
    model: {
      value: (_vm.assignCampaignDialog),
      callback: function($$v) {
        _vm.assignCampaignDialog = $$v
      },
      expression: "assignCampaignDialog"
    }
  }), _vm._v(" "), _c('map-influencer-modal', {
    attrs: {
      "post": _vm.mapInfluencerPostData
    },
    on: {
      "successInfluencerMap": function($event) {
        return _vm.influencerMapSuccess($event)
      }
    },
    model: {
      value: (_vm.mapInfluencerDialog),
      callback: function($$v) {
        _vm.mapInfluencerDialog = $$v
      },
      expression: "mapInfluencerDialog"
    }
  }), _vm._v(" "), _c('submission-review-multiple-modal', {
    attrs: {
      "posts": _vm.selected,
      "internalApprove": false
    },
    on: {
      "successBulkApprove": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.submissionReviewMultipleDialog),
      callback: function($$v) {
        _vm.submissionReviewMultipleDialog = $$v
      },
      expression: "submissionReviewMultipleDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('add-post-to-campaign', {
    attrs: {
      "value": _vm.addPostToCampaign,
      "campaign": _vm.campaignDataForAddPost,
      "postID": _vm.postIdToUpdate
    },
    on: {
      "done": _vm.postAdded
    },
    model: {
      value: (_vm.addPostToCampaign),
      callback: function($$v) {
        _vm.addPostToCampaign = $$v
      },
      expression: "addPostToCampaign"
    }
  }), _vm._v(" "), _c('change-post-status-modal', {
    attrs: {
      "post": _vm.postDataForChangeStatus
    },
    on: {
      "updated": function($event) {
        return _vm.getPosts()
      }
    },
    model: {
      value: (_vm.changeStatusDialog),
      callback: function($$v) {
        _vm.changeStatusDialog = $$v
      },
      expression: "changeStatusDialog"
    }
  }), _vm._v(" "), _c('client-choose-date-modal', {
    attrs: {
      "post": _vm.viewChooseDatePost,
      "ChooseDateDialogValue": _vm.chooseDateDialog
    },
    on: {
      "chooseDateClosed": _vm.closeChooseDateModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e628526"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/index.vue
// module id = 2061
// module chunks = 0